export default {"src":"/_next/static/media/for-creators-1.3d341ce1.svg","height":979,"width":1440};